<template>
  <div class="display-container section_8">
    <div class="flex flex-row justify-between items-start">
      <div class="space-x-9">
        <div v-if="!data.titleHidden" class="font_4">{{ data.title }}</div>
        <div v-if="!data.subtitleHidden" class="font_7">
          {{ data.subtitle }}
        </div>
      </div>
      <div v-if="data.showMoreButton" class="flex flex-row items-center justify-center">
        <span class="font_5 text_14">更多</span>
        <img class="image_7" src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/5b228aff321d47c18ec1ef371875389c.png" alt="" />
      </div>
    </div>

    <div class="contact-list flex items-center justify-between">
      <div v-for="contact of dataList.slice(0, 2)" :key="contact.id" class="contact-item">
        <div class="header flex items-center">
          <img :src="contact.uavatar" alt="" class="avatar" />
          <div class="info">
            <div class="name line-clamp-1">{{ contact.uname }}</div>
            <div class="post line-clamp-1">{{ contact.identityPost || contact.memberPost }}</div>
          </div>
        </div>
        <div class="footer line-clamp-1">{{ contact.unit || contact.chamberName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
    dataList: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {}
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
}
</script>

<style lang="less" scoped>
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.display-container {
  width: 686px;
  margin: 0 auto;
  background: url(https://ysh-cdn.kaidicloud.com/test/2024/05/06/ec646e0afa034fd4b97f409f601e21e0.png);
  background-size: cover;

  .contact-list {
    margin-top: 16px;
  }

  .contact-item {
    width: 308px;
    height: 188px;
    background: url(https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/27/2dd8c41ff67b4bf6a819751d2cbb0433.png);
    background-size: cover;
    padding: 24px 24px 12px;
    border-radius: 16px;

    .header {
      border-bottom: 2px solid #ffffff;
      padding-bottom: 16px;
    }

    .avatar {
      width: 84px;
      height: 84px;
      border-radius: 8px;
      border: 2px solid #d5d5d5;
      flex-shrink: 0;
    }

    .info {
      margin-left: 8px;
    }

    .name {
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
      line-height: 42px;
      max-width: 168px;
    }

    .post {
      font-size: 24px;
      color: #ffffff;
      line-height: 34px;
    }

    .footer {
      font-size: 28px;
      color: #ffffff;
      line-height: 40px;
      margin-top: 10px;
    }
  }
}

.section_8 {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  .space-x-9 {
    & > *:not(:first-child) {
      margin-left: 18px;
    }
    .font_4 {
      font-size: 34px;
      line-height: 48px;
      font-weight: 500;
      color: #222;
    }
  }
  .font_5 {
    font-size: 24px;
    line-height: 34px;
    color: #999999;
  }
  .text_14 {
    font-size: 26px;
    line-height: 36px;
  }
  .image_7 {
    width: 8px;
    height: 14px;
    flex-shrink: 0;
    margin-left: 8px;
  }

  .font_7 {
    font-size: 24px;
    line-height: 34px;
    color: #717171;
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>
